"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconButtonNeoDark = exports.iconButtonNeoLight = exports.iconButtonNovoDark = exports.iconButtonNovo = exports.iconButton = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const iconButtonNovo = {
    color: light.icon01,
    colorDisabled: light.icon03,
    colorInverted: dark.icon01,
    colorInvertedDisabled: dark.icon03,
    backgroundHover: light.hover05,
    backgroundActive: light.active05,
    backgroundHoverInverted: dark.hover05,
    backgroundActiveInverted: dark.active05,
    borderFocus: light.focus01,
    borderFocusInverted: dark.focus01,
};
exports.iconButtonNovo = iconButtonNovo;
const iconButtonNovoDark = {
    color: dark.icon01,
    colorDisabled: dark.icon03,
    colorInverted: light.icon01,
    colorInvertedDisabled: light.icon03,
    backgroundHover: dark.hover05,
    backgroundActive: dark.active05,
    backgroundHoverInverted: light.hover05,
    backgroundActiveInverted: light.active05,
    borderFocus: dark.focus01,
    borderFocusInverted: light.focus01,
};
exports.iconButtonNovoDark = iconButtonNovoDark;
const iconButtonNeoLight = {
    ...iconButtonNovo,
    color: neoLight.icon01,
    colorDisabled: neoLight.icon03,
    colorInverted: neoDark.icon01,
    colorInvertedDisabled: neoDark.icon03,
    backgroundHover: neoLight.hover13,
    backgroundActive: neoLight.active12,
    backgroundHoverInverted: neoDark.hover13,
    backgroundActiveInverted: neoDark.active12,
    borderFocus: neoLight.focus01,
    borderFocusInverted: neoDark.focus01,
};
exports.iconButtonNeoLight = iconButtonNeoLight;
const iconButtonNeoDark = {
    ...iconButtonNovoDark,
    color: neoDark.icon01,
    colorDisabled: neoDark.icon03,
    colorInverted: neoLight.icon01,
    colorInvertedDisabled: neoLight.icon03,
    backgroundHover: neoDark.hover13,
    backgroundActive: neoDark.active12,
    backgroundHoverInverted: neoLight.hover13,
    backgroundActiveInverted: neoLight.active12,
    borderFocus: neoDark.focus01,
    borderFocusInverted: neoLight.focus01,
};
exports.iconButtonNeoDark = iconButtonNeoDark;
const iconButton = iconButtonNovo;
exports.iconButton = iconButton;
